import { Edit, Group, Login } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { useCallback, useMemo, useState } from "react";
import { Table } from "../../../components/Table";
import { useStyles } from "../styles";
import SmsIcon from "../../../assets/campaign/sms.png";
import WhatsAppIcon from "../../../assets/campaign/whatsapp.png";
import EmailIcon from "../../../assets/campaign/email.png";
import InstagramIcon from "../../../assets/campaign/instagram.png";
import FacebookIcon from "../../../assets/campaign/facebook.png";
import { Campaign as TypeCampaign } from "../../../types/results";
import { useNavigate } from "react-router-dom";
import { DialogEdit } from "../Edit";
import { CountUp } from "../../../components/CountUp";
import { parseISO } from "date-fns";
import { DialogProfile } from "../../../components/DialogProfile";

type CampaignProps = {
  data: TypeCampaign[];
  loading?: boolean;
};

export function Campaign({ data, loading }: CampaignProps) {
  const styles = useStyles();
  const navigate = useNavigate();
  const [campaign, setCampaign] = useState<TypeCampaign>();
  const [dialogProfile, setDialogProfile] = useState<boolean>(false);
  const [dialogEditCampaign, setDialogEditCampaign] = useState<boolean>(false);

  const iconsCampaigns = useMemo(() => {
    return {
      email: EmailIcon,
      sms: SmsIcon,
      sms_v2: SmsIcon,
      whatsapp: WhatsAppIcon,
      instagram: InstagramIcon,
      facebook: FacebookIcon,
    };
  }, []);

  const handleDialogProfile = useCallback((row: TypeCampaign) => {
    setCampaign(row);
    setDialogProfile((prev) => !prev);
  }, []);

  const handleDialogEdit = useCallback((row: TypeCampaign) => {
    setCampaign(row);
    setDialogEditCampaign((prev) => !prev);
  }, []);

  const handleDetailsCampaign = useCallback(
    (row: TypeCampaign) => {
      navigate(String(row.ID_CAMPANHA), {
        state: {
          name: row.nome_campanha,
          startDate: parseISO(
            String(row.data_inicio_campanha)?.replace("Z", "")
          ),
          endDate: parseISO(String(row.data_fim_campanha)?.replace("Z", "")),
        },
      });
    },
    [navigate]
  );

  const RenderName = (item: TypeCampaign) => {
    return (
      <Stack direction="row" spacing={1} alignItems="center">
        <img
          className={styles.imgIcon}
          src={iconsCampaigns[String(item.tipo_campanha).toLowerCase()]}
          alt="sms-icon"
        />
        <Typography>{item.nome_campanha}</Typography>
      </Stack>
    );
  };

  return (
    <>
      <Paper
        variant="outlined"
        elevation={0}
        className={styles.paperCreatedDay}
      >
        <Table
          isLoading={loading}
          toolbar={false}
          data={data}
          columns={[
            { title: "Nome", field: "nome_campanha", render: RenderName },
            {
              title: "Alcance",
              field: "pessoas_alcancadas",
              render: (row) => (
                <CountUp start={0} end={Number(row.pessoas_alcancadas)} />
              ),
            },
            {
              title: "Investimento",
              field: "gastos_campanha",
              render: (row) => (
                <CountUp
                  end={Number(row?.gastos_campanha)}
                  prefix="R$"
                  decimals={2}
                  start={0}
                />
              ),
            },
            {
              title: "Vendas",
              field: "qtde_vendas",
              render: (row) => (
                <CountUp start={0} end={Number(row.qtde_vendas)} />
              ),
            },
            {
              title: "Faturamento",
              field: "valor_vendas",
              render: (row) => (
                <CountUp
                  prefix="R$"
                  decimals={2}
                  start={0}
                  end={Number(row.valor_vendas)}
                />
              ),
            },
            {
              title: "ROI",
              field: "valor_roi",
              render: (row) => (
                <CountUp
                  prefix="R$"
                  decimals={2}
                  start={0}
                  end={Number(row.valor_roi)}
                />
              ),
            },
            {
              title: "Margem",
              field: "margem_percentual",
              render: (row) => (
                <CountUp
                  suffix="%"
                  decimals={2}
                  start={0}
                  end={Number(row.margem_percentual)}
                />
              ),
            },
            {
              title: "Ações",
              render: (row) => (
                <Stack spacing={1} direction="row">
                  <Tooltip title="Ver detalhes" placement="top">
                    <IconButton onClick={() => handleDetailsCampaign(row)}>
                      <Login />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Clientes" placement="top">
                    <IconButton onClick={() => handleDialogProfile(row)}>
                      <Group />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Editar" placement="top">
                    <IconButton onClick={() => handleDialogEdit(row)}>
                      <Edit />
                    </IconButton>
                  </Tooltip>
                </Stack>
              ),
            },
          ]}
          style={{ backgroundColor: "transparent" }}
          headerStyle={{ backgroundColor: "transparent" }}
          options={{
            actionsColumnIndex: -1,
            pageSize: 7,
            selectionProps: () => ({
              color: "primary",
            }),
          }}
        />
      </Paper>
      <DialogProfile
        data={campaign}
        open={dialogProfile}
        onClose={() => {
          handleDialogProfile(null);
        }}
      />
      <DialogEdit
        data={campaign}
        open={dialogEditCampaign}
        onClose={() => {
          handleDialogEdit(null);
        }}
      />
    </>
  );
}
